





















import { Component, Prop, Vue } from 'vue-property-decorator';
import { IClass } from '@/models/Classes';
import { IModule, IRefModule } from '@/models/Modules';
import Modules from '@/services/Modules';
import Classroom from '@/services/Classroom';

@Component
export default class EditClassroomModuleName extends Vue {
  @Prop({ required: true }) public data!: any;

  public moduleName = '';
  public classroom: IClass = this.data.classroom;
  public moduleId: string = this.data.moduleId;

  public async created() {
    const moduleRefToEdit = (this.classroom.modules as IRefModule[]).find(
      m => m.id === this.moduleId
    );

    if (moduleRefToEdit?.nameOverride) {
      this.moduleName = moduleRefToEdit.nameOverride;
    } else {
      const module = (await Modules.getModuleById(this.moduleId)) as IModule;
      this.moduleName = module?.name || '';
    }
  }

  public mounted() {
    (this.$refs.first as HTMLInputElement).focus();
  }

  async editName(e: any) {
    e.preventDefault();

    const ref = (this.classroom.modules as IRefModule[]).find(m => m.id === this.moduleId);
    if (!ref) {
      return;
    }

    if (this.moduleName) {
      ref.nameOverride = this.moduleName;
    } else {
      // By leaving the name empty, it will fall back to the original
      delete ref.nameOverride;
    }

    await Classroom.updateClassRoomModuleOrder(
      this.classroom.uuid,
      this.classroom.modules as IRefModule[]
    );
    this.closeModal();
  }

  closeModal() {
    this.$parent.$emit('close-modal');
  }
}
